import { render, staticRenderFns } from "./sexRatio.vue?vue&type=template&id=5d813084&scoped=true"
import script from "./sexRatio.vue?vue&type=script&lang=js"
export * from "./sexRatio.vue?vue&type=script&lang=js"
import style0 from "./sexRatio.vue?vue&type=style&index=0&id=5d813084&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d813084",
  null
  
)

export default component.exports